<header
  #headerElement
  id="header"
  class="d-flex justify-content-between"
  [class.landscape-header-override]="displayService.isLandscape"
  [class.portrait-header-override]="displayService.isPortrait"
  [class.portrait-subnav-override]="displayService.isPortrait && displayService.isSubnavRoute"
>
  <div class="d-flex">
    <div class="d-flex flex-column">
      <h1 class="page-title" [title]="'' | translate">
        <a *ngIf="titleBack" class="d-block" (click)="onBack.emit()" [title]="'' | translate">
          <mat-icon svgIcon="iconArrowLeft"></mat-icon>
          {{ titleBack | translate }}
        </a>
        <ng-container *ngIf="title; else noTitle">
          <ng-container *ngIf="groupAccounts.length > 0 && title === accountTitle; else withTitleOnly">
            <div [matMenuTriggerFor]="withTitleDealerGroupAccounts">
              {{ title | translate }}
              <mat-icon mat-button class="expand-accounts-list-btn">expand_more</mat-icon>
              <mat-menu #withTitleDealerGroupAccounts="matMenu" yPosition="below" class="dealer-group-accounts">
                <button mat-menu-item *ngFor="let account of groupAccounts" (click)="switchAccount(account)">
                  {{ account.account ?? accountTitleFallback }}
                </button>
              </mat-menu>
            </div>
          </ng-container>
          <ng-template #withTitleOnly>
            {{ title | translate }}
          </ng-template>
        </ng-container>
        <ng-template #noTitle>
          <ngx-skeleton-loader [theme]="{ width: '250px', height: '46px' }"></ngx-skeleton-loader>
        </ng-template>
      </h1>
      <ng-container *ngIf="(accountTitle && title !== accountTitle) || accountTitleFallback; else standAloneIcon">
        <ng-container *ngIf="!isDataLoading; else loading">
          <ng-container *ngIf="groupAccounts.length === 0; else groupDropdown">
            <div class="d-flex">
              <h2 id="navigate" (click)="navigateToAccountHome()" class="account-title" [title]="'' | translate">
                {{ accountTitle ?? accountTitleFallback }}
              </h2>
              <mat-icon
                *ngIf="isAggregator"
                class="aggregator-icon"
                [matTooltip]="'accounts.aggregatorAccount' | translate"
                matTooltipPosition="after"
                >font_download</mat-icon
              >
            </div>
          </ng-container>
          <ng-template #groupDropdown>
            <div class="d-flex" [matMenuTriggerFor]="dealerGroupAccounts">
              <h2 id="navigate" class="account-title" [title]="'' | translate">
                {{ accountTitle ?? accountTitleFallback }}
              </h2>
              <mat-icon
                *ngIf="isAggregator"
                class="aggregator-icon"
                [matTooltip]="'accounts.aggregatorAccount' | translate"
                matTooltipPosition="after"
                >font_download</mat-icon
              >
              <mat-icon mat-button class="expand-accounts-list-btn">expand_more</mat-icon>
              <mat-menu #dealerGroupAccounts="matMenu" yPosition="below" class="dealer-group-accounts">
                <button mat-menu-item *ngFor="let account of groupAccounts" (click)="switchAccount(account)">
                  {{ account.account ?? accountTitleFallback }}
                </button>
              </mat-menu>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #loading>
          <ngx-skeleton-loader [theme]="{ width: '120px', height: '16px' }"></ngx-skeleton-loader>
        </ng-template>
      </ng-container>
      <ng-template #standAloneIcon>
        <ng-container *ngIf="!isDataLoading">
          <mat-icon
            *ngIf="isAggregator"
            class="stand-alone-aggregator-icon"
            [matTooltip]="'accounts.aggregatorAccount' | translate"
            matTooltipPosition="after"
            >font_download</mat-icon
          >
        </ng-container>
      </ng-template>
    </div>
    <ng-content select="#add-on-content"></ng-content>
  </div>

  <div id="content" [class.portrait-content-override]="displayService.isPortrait">
    <!-- Element Content -->
    <ng-content></ng-content>
    <ng-container *ngIf="title && titleAction">
      <button
        *ngIf="!actionHidden"
        (click)="onAction.emit()"
        [disabled]="actionDisabled"
        mat-raised-button
        color="primary"
      >
        {{ titleAction | translate }}
      </button>
    </ng-container>
  </div>
</header>
